import InputText from 'components/Form/InputText'
import { FieldArray, useFormikContext } from 'formik'
import React, { useCallback, useEffect, useState, useLayoutEffect, useRef } from 'react'
import Checkbox, { LabelWrapper } from 'components/Form/Checkbox'
import { StyledInputCustom } from 'components/UIComponents/FormStyles'
import { scores } from 'utils/const'
import {
  ArrearSubText,
  Chart,
  ChartElement,
  Level,
  Marks,
  SubChart,
  TypeGroup,
} from '../../style/style'
import DropDown from 'components/Form/DropDown'
import RadioGroupField from 'components/Form/RadioGroupField'
import { educationLevels } from 'utils/const'
import { Wrapper } from '../../../RolesForm/Partials/CtcJoblocation/Style/style'
import CourseTable from './CourseTable'
import Skills from './Skills'
import { CourseBox, MarginDiv, QualificationLevelSwitch } from './style'
import { useDataFetch } from 'hooks/useDataFetch'
import LabelInput from 'components/Form/LabelInput'
import { getLabel } from 'helpers/formHelpers'
import { debounce } from 'utils/debounce'
import Button from 'components/Button'
import { Divider, Space, Spin, Typography } from 'antd'
import InformationIcon from '../../../../../../../components/icons/Informationicon'

function flattenEligibility(arr) {
  if (!Array.isArray(arr)) return []
  return arr.reduce((acc, item) => {
    if (Array.isArray(item)) {
      acc.push(...item)
    } else if (item && typeof item === 'object') {
      acc.push(item)
    }
    return acc
  }, [])
}
export const transformQualification = previewData => {
  if (!previewData?.eligibilityCriteria?.length) {
    return []
  }
  return previewData.eligibilityCriteria.map(criteria => {
    return criteria.qualification || []
  })
}
export const transformPreviewData = previewData => {
  if (!previewData?.eligibilityCriteria?.length) {
    return [[]]
  }

  const transformed = previewData.eligibilityCriteria.map((criteria, index) => {
    if (!criteria?.selected) {
      return []
    }

    const result = []

    // Handle allDegree entries
    const allDegreeEntries = Object.entries(criteria.selected).filter(
      ([_, degrees]) =>
        Array.isArray(degrees) && degrees.some(deg => deg?.isAllDegree)
    )

    allDegreeEntries.forEach(([degreeType, degrees]) => {
      const allDegreeItem = degrees.find(deg => deg?.isAllDegree)
      if (allDegreeItem) {
        result.push({
          degreeType,
          isAllDegree: true,
        })
      }
    })

    // Handle all selected degrees, including those without isAllDegree
    const allSelectedDegrees = Object.entries(criteria.selected).flatMap(
      ([degreeType, degrees]) => {
        if (!Array.isArray(degrees)) return []

        return degrees
          .map(degree => {
            if (!degree) return null

            // If isAllDegree is present, skip to avoid duplication
            if (degree.isAllDegree) return null

            return {
              degreeId: degree.id || degree.degreeId,
              degreeName: degree.name || degree.degreeName,
              degreeShortForm: degree.shortForm || degree.degreeShortForm,
              degreeType: degreeType,
              isSelected: true, // Assume selection if present in array
              degreeStatus: 1,
              domainStatus: 1,
              status: 1,
              orderType: 2,
              streams: (degree.streams || []).map(stream => ({
                streamId: stream.id || stream.streamId,
                streamName: stream.name || stream.streamName,
                isSelected: true,
                specializations: (
                  stream.specializations ||
                  stream.specialisations ||
                  []
                ).map(spec => ({
                  specialisationId: spec.id || spec.specialisationId,
                  specialisationName: spec.name || spec.specialisationName,
                  isSelected: true,
                })),
              })),
            }
          })
          .filter(Boolean)
      }
    )

    // Combine results
    return [...result, ...allSelectedDegrees]
  })

  return transformed
}
const EligibilityCriteria = ({
  courseData,
  setCourseData,
  getYearOfPassing,
  yearOfPassing,
  listOfSkills,
  listOfDegree,
  handleSearch,
  skillLoading,
  getListOfDegree,
  getEligibilityCriteriaQualification,
  handleQualicationChange,
  degreeLoading,
  getListOfSkills,
  publishDisabled,
  rePublishedPublishDisabled,
  setSearch,
  updateJobRole,
  jobId,
  setSelectedCourses,
  selectedCourses,
  setIsAllSelected,
  isAllSelected,
  search,
  skillRefetch,
  fetchRoleDetails,
  previewData,
  isBubbleLoading,
  setIsBubbleLoading,
  type,
  roleData,
}) => {
  const { values, errors, touched, setFieldValue, handleBlur } =
    useFormikContext()
  const [yearSearch, setYearSearch] = useState('')
  const [isLoading, setIsLoading] = useState(true)
  const [localSearch, setLocalSearch] = useState(search || '')
  const { data: dataOfYearOfPassing } = useDataFetch(
    getYearOfPassing,
    [yearSearch],
    [yearSearch]
  )
  const { Text } = Typography
  const [courseList, setCourseList] = useState([])
  const [activeIndex, setActiveIndex] = useState(0)
  const [expandedDegrees, setExpandedDegrees] = useState([])
  const [expandedStreams, setExpandedStreams] = useState([])
  const [hasInitialized, setHasInitialized] = useState(false)
  const hasAppliedFallback = useRef(false)

  // Helper function to display labels
  const getQualificationLabel = (qualification) => {
    return qualification === 'DIPLOMA' ? 'DIPLOMA / ITI' : qualification
  }

  const fetchBubbleData = useCallback(() => {
    if (!listOfDegree?.length) return

    setIsBubbleLoading(true)
    const initialized = initializeCourseData(
      listOfDegree,
      values.elgibilty.eligibilityCriteria
    )
    setCourseData(initialized)
    fetchRoleDetails(jobId)
    const transformed = transformPreviewData(previewData)
    const qualification = transformQualification(previewData)
    setSelectedDegreeTypes(qualification)
    setSelectedCourses(prev => {
      const prevArray = Array.isArray(prev)
        ? [...prev]
        : Array(values.elgibilty.eligibilityCriteria.length).fill([])
      transformed.forEach((criteriaData, index) => {
        prevArray[index] = Array.isArray(criteriaData) ? criteriaData : []
      })
      setIsBubbleLoading(false)
      return [...prevArray]
    })
  }, [listOfDegree, values.elgibilty.eligibilityCriteria, jobId, previewData])
 
  useEffect(() => {
    const loadData = async () => {
      if (hasInitialized || !listOfDegree?.length) return

      try {
        setIsLoading(true)
        setCourseData(listOfDegree)
        const labelList = getLabel(listOfDegree)
        setCourseList(prev => [...new Set([...prev, ...labelList])])
        setSearch(prev => ({
          ...prev,
          selectedType: 'UG',
        }))

        if (!selectedCourses?.length) {
          await fetchBubbleData()
        }
        setHasInitialized(true)
      } catch (error) {
        console.error('Error loading data:', error)
      } finally {
        setIsLoading(false)
      }
    }

    loadData()
  }, [listOfDegree, previewData, hasInitialized, fetchBubbleData])

  useEffect(() => {
    if (!hasAppliedFallback.current && hasInitialized && values.elgibilty?.eligibilityCriteria) {
      const firstIndexWithSelection = values.elgibilty.eligibilityCriteria.findIndex(
        (criteria, index) => Array.isArray(criteria) && criteria.length > 0
      )
      if (firstIndexWithSelection !== -1) {
        const criteriaAtIndex = values.elgibilty.eligibilityCriteria[firstIndexWithSelection]
        const firstItem = criteriaAtIndex[0]
        const actualDegreeType = firstItem?.degreeType || firstItem?.type || 'UG'
        setActiveIndex(firstIndexWithSelection)
        setSearch(prev => ({
          ...prev,
          selectedType: actualDegreeType,
        }))
        setFieldValue(`elgibilty.qualification[${firstIndexWithSelection}]`, actualDegreeType)
      }
      hasAppliedFallback.current = true
    }
  }, [hasInitialized])
  const debouncedSearch = useCallback(
    debounce((searchTerm, degrees) => {
      if (!searchTerm) {
        setExpandedDegrees([])
        setExpandedStreams([])
        return
      }

      // The search API matches per-word, OR'd across degree/stream/specialisation
      // columns (e.g. "mba market" = "mba" hits the degree, "market" hits a nested
      // specialisation) — mirror that here. Matching the whole phrase as one
      // substring meant a multi-word query never matched any single field, so
      // nothing ever auto-expanded and the result rendered as a bare degree row
      // with blank Department/Specialization columns.
      // Also strip punctuation, same as the backend: short forms like "M.B.A"
      // otherwise never match a plain "mba" query.
      const stripToAlnum = value => (value || '').toLowerCase().replace(/[^a-z0-9]/g, '')
      const fieldContainsWord = (field, word) => {
        const raw = (field || '').toLowerCase()
        return raw.includes(word) || stripToAlnum(field).includes(word)
      }
      const words = searchTerm
        .toLowerCase()
        .split(/\s+/)
        .map(stripToAlnum)
        .filter(Boolean)
      let matchedDegreeIds = []
      let matchedStreamIds = []

      degrees.forEach(deg => {
        const degreeFields = [deg.degreeShortForm, deg.degreeName]
        const wordsHitDegree = new Set(
          words.filter(w => degreeFields.some(f => fieldContainsWord(f, w)))
        )

        const streamHits = []
        deg.streams?.forEach(stream => {
          const specs =
            stream.specializations || stream.specialisations || []
          const wordsHere = new Set(
            words.filter(
              w =>
                fieldContainsWord(stream.streamName, w) ||
                specs.some(spec => fieldContainsWord(spec.specialisationName, w))
            )
          )
          if (wordsHere.size > 0) {
            streamHits.push({ streamId: stream.streamId, words: wordsHere })
          }
        })

        // Every word must be accounted for somewhere in this degree's subtree
        // (the degree itself, or any of its streams/specialisations) — but not
        // necessarily the same node, since "mba" and "market" match different
        // levels of the same degree.
        const allWordsCovered = words.every(
          w => wordsHitDegree.has(w) || streamHits.some(h => h.words.has(w))
        )

        if (allWordsCovered && (wordsHitDegree.size > 0 || streamHits.length > 0)) {
          matchedDegreeIds.push(deg.degreeId)
          streamHits.forEach(h => matchedStreamIds.push(h.streamId))
        }
      })

      setExpandedDegrees([...new Set(matchedDegreeIds)])
      setExpandedStreams([...new Set(matchedStreamIds)])
    }, 500),
    []
  )

  useEffect(() => {
    if (listOfDegree?.length) {
      setCourseData(listOfDegree)
      const labelList = getLabel(listOfDegree)
      setCourseList(prev => [...new Set([...prev, ...labelList])])

      if (localSearch) {
        debouncedSearch(localSearch, listOfDegree)
      } else {
        setExpandedDegrees([])
        setExpandedStreams([])
      }
    }
    else{
      setCourseData([])
      // setCourseList([])
      setExpandedDegrees([])
      setExpandedStreams([])
    }
  }, [listOfDegree, localSearch, debouncedSearch])

  const handleQualificationSelect = useCallback(
    async (qualification, index) => {
      setLocalSearch('')
      setExpandedDegrees([])
      setExpandedStreams([])
      setSearch(prev => ({ ...prev, degree: '' }))
      const currentQualification = Array.isArray(values.elgibilty.qualification)
        ? values.elgibilty.qualification.filter(Boolean)
        : []

      const newTypes = [...currentQualification]
      newTypes[index] = qualification
      const cleanTypes = newTypes.filter(Boolean)
      setFieldValue('elgibilty.qualification', cleanTypes)
      setSearch({ ...search, selectedType: qualification })

      const newEligibilityCriteria = Array.isArray(
        values.elgibilty.eligibilityCriteria
      )
        ? [...values.elgibilty.eligibilityCriteria]
        : []
      setFieldValue('elgibilty.eligibilityCriteria', newEligibilityCriteria)

      // if (jobId) {
      //   await updateJobRole(
      //     {
      //       ...values,
      //       elgibilty: { ...values.elgibilty, qualification: cleanTypes },
      //     },
      //     jobId
      //   )
      // }
      // fetchBubbleData()

      // setCourseData(prevData =>
      //   prevData.map(degree => {
      //     if (degree.type === qualification) {
      //       return {
      //         ...degree,
      //         isSelected: false,
      //         streams: (degree.streams || []).map(stream => ({
      //           ...stream,
      //           isSelected: false,
      //           specializations: (
      //             stream.specializations ||
      //             stream.specialisations ||
      //             []
      //           ).map(spec => ({
      //             ...spec,
      //             isSelected: false,
      //           })),
      //         })),
      //       }
      //     }
      //     return degree
      //   })
      // )

      setActiveIndex(index)
    },
    [
      setFieldValue,
      values.elgibilty.qualification,
      values.elgibilty.eligibilityCriteria,
      setCourseData,
      jobId,
      updateJobRole,
      setSearch,
    ]
  )

  function initializeCourseData(apiData, selectedCriteria) {
    const criteriaList = Array.isArray(selectedCriteria)
      ? flattenEligibility(selectedCriteria)
      : []

    return apiData?.map(degree => {
      const degreeSelected = criteriaList.some(
        c => c?.degreeId === degree?.degreeId && !c?.streamId
      )
      const updatedStreams = (degree.streams || []).map(stream => {
        const streamSelected = criteriaList.some(
          c =>
            c?.degreeId === degree?.degreeId &&
            c?.streamId === stream?.streamId &&
            (!c?.specialisationId || c?.specialisationId?.length === 0)
        )
        const updatedSpecs = (
          stream.specializations ||
          stream.specialisations ||
          []
        ).map(spec => {
          const specSelected = criteriaList.some(
            c =>
              c?.degreeId === degree?.degreeId &&
              c?.streamId === stream?.streamId &&
              c?.specialisationId?.includes(spec?.specialisationId || spec?.id)
          )
          return { ...spec, isSelected: specSelected }
        })
        return {
          ...stream,
          isSelected: streamSelected || updatedSpecs.some(s => s.isSelected),
          specializations: updatedSpecs,
        }
      })
      const isDegreeSelected =
        degreeSelected ||
        updatedStreams.some(
          s =>
            s.isSelected ||
            (s.specializations || []).some(spec => spec.isSelected)
        )
      return {
        ...degree,
        isSelected: isDegreeSelected,
        streams: updatedStreams,
      }
    })
  }

  const getFieldError = field =>
    touched[`elgibilty.${field}`] && errors.elgibilty?.[field]
      ? errors.elgibilty[field]
      : undefined

  const yearOptions = yearOfPassing?.map(year => ({
    value: year,
    label: String(year),
  }))

  const filteredData = useCallback(
    type => {
      if (!Array.isArray(courseData)) return []
      return courseData.filter(
        item =>
          item &&
          item.type &&
          String(item.type).trim().toLowerCase() ===
            String(type || '')
              .trim()
              .toLowerCase()
      )
    },
    [courseData]
  )

  const [selectedDegreeTypes, setSelectedDegreeTypes] = useState([])

  useEffect(() => {
   // Check if data exists and has the correct format
    const data = values.elgibilty.eligibilityCriteria

    // if(data == []){
    //   setFieldValue('elgibilty.eligibilityCriteria', [data])
    //   return
    // }
    if ((Array.isArray(data) && Array.isArray(data[0])) || (Array.isArray(data) && data.length === 0)) {
      // Already in correct format or empty array, no need to transform
      return
    }
    
    // Handle empty array case - transform [] to [[]]
 
    // Otherwise, transform the data to ensure it's an array of arrays
    let normalizedData
    if (Array.isArray(data)) {
      // It's an array but not an array of arrays, so wrap it: [items] -> [[items]]
      normalizedData = [data]
    } else {
      // It's not even an array, so create an empty array of arrays
      normalizedData = [[]]
    }
    
    // Update the form field with normalized data
    setFieldValue('elgibilty.eligibilityCriteria', normalizedData)
  }, [values.elgibilty.eligibilityCriteria, setFieldValue])   

  const flatSelectedDegrees = selectedDegreeTypes.flat()

  // Check if all courseList items are in selectedDegreeTypes
  const shouldDisableButton = courseList.every(item =>
    flatSelectedDegrees.includes(item)
  )

  const filteredEducationLevels = educationLevels.filter(level => {
    const levelName = level.name

    if (flatSelectedDegrees.includes(levelName)) {
      return true
    }

    return (
      levelName === '10TH' ||
      levelName === '12TH' ||
      selectedDegreeTypes.flat().includes(levelName)
    )
  })
console.log(selectedDegreeTypes,flatSelectedDegrees,'degreeTypes')
  const isOffCampus = values?.jobDetails?.isForAll === true

  return (
    <>
      {isOffCampus && (
        <div style={{
          background: '#EBF5FF',
          border: '1px solid #B3D4FC',
          borderRadius: '8px',
          padding: '12px 16px',
          marginBottom: '16px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          color: '#1A5DAD',
          fontSize: '13px',
          lineHeight: '18px',
        }}>
          <InformationIcon />
          <span>For Off Campus / Lateral hiring, eligibility criteria fields are optional. You may still set them for filtering purposes.</span>
        </div>
      )}
      {isBubbleLoading ? (
        <Spin />
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1em' }}>
          <LabelInput>Qualification {isOffCampus ? '' : '*'}</LabelInput>
          <FieldArray name="elgibilty.eligibilityCriteria">
            {({ push, remove }) => (
              <>
                {values.elgibilty?.eligibilityCriteria?.map((_, idx) => (
                  <div key={idx}>
                    <TypeGroup width="100%">
                      {courseList?.map((item, index) => {
                        // Check if this item is selected in any other table
                        let isSelectedInOtherTable = false

                        // Check each table's selected degree types
                        selectedDegreeTypes.forEach((types, i) => {
                          if (
                            i !== idx &&
                            Array.isArray(types) &&
                            types.includes(item)
                          ) {
                            isSelectedInOtherTable = true
                          }
                        })

                        return (
                          <CourseBox key={index} handleSearch={handleSearch}>
                            <QualificationLevelSwitch
                              $selected={
                                values.elgibilty.qualification?.[idx] ===
                                  item ?? 'UG'
                              }
                              type="primary"
                              disabled={
                                rePublishedPublishDisabled ||
                                isSelectedInOtherTable
                              }
                              value={values?.elgibilty?.qualification?.[idx]}
                              name={item}
                              onClick={() =>
                                handleQualificationSelect(item, idx)
                              }
                              $disabled={
                                publishDisabled || isSelectedInOtherTable
                              }
                              // onBlur={handleBlur}
                              style={{
                                opacity: isSelectedInOtherTable ? 0.5 : 1,
                                cursor: isSelectedInOtherTable
                                  ? 'not-allowed'
                                  : 'pointer',
                                border: !isSelectedInOtherTable && flatSelectedDegrees.includes(item) && '1px solid #3249D7',
                              }}
                            >
                              {getQualificationLabel(item)}
                            </QualificationLevelSwitch>
                          </CourseBox>
                        )
                      })}
                    </TypeGroup>
                    {errors.elgibilty?.eligibilityCriteria && (
                      <p style={{ color: 'red' }}>
                        {getFieldError('eligibilityCriteria')}
                      </p>
                    )}
                    {/* {filteredData(values.elgibilty.qualification?.[idx])?.length > 0 && ( */}

                    <CourseTable
                      data={filteredData(
                        values.elgibilty.qualification?.[idx] ?? 'UG'
                      )}
                      setCourseData={setCourseData}
                      handleSearch={handleSearch}
                      degreeLoading={degreeLoading}
                      disabled={rePublishedPublishDisabled}
                      setSearch={setSearch}
                      courseData={courseData}
                      setSelectedCourses={setSelectedCourses}
                      selectedCourses={selectedCourses}
                      isAllSelected={isAllSelected}
                      setIsAllSelected={setIsAllSelected}
                      search={search}
                      criteria={idx}
                      type={type}
                      selectedDegreeTypes={selectedDegreeTypes}
                      setSelectedDegreeTypes={setSelectedDegreeTypes}
                      active={activeIndex === idx} // Pass active state
                      localSearch={localSearch}
                      setLocalSearch={setLocalSearch}
                      expandedDegrees={expandedDegrees}
                      setExpandedDegrees={setExpandedDegrees}
                      expandedStreams={expandedStreams}
                      setExpandedStreams={setExpandedStreams}
                    />
                    {/* //)} */}
                    {values.elgibilty.eligibilityCriteria.length - 1 > idx && (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          fontWeight: '600',
                        }}
                      >
                        <Divider>AND</Divider>
                      </div>
                    )}
                    {idx === values.elgibilty.eligibilityCriteria.length - 1 &&
                      values.elgibilty.eligibilityCriteria.length <
                        courseList.length && (
                        <>
                          {!shouldDisableButton && (
                            <Space>
                              <Button.Secondary
                                text="+ Add 'And'"
                                borderColor="#D6DBF7"
                                onClick={() => push([])}
                                disabled={
                                  rePublishedPublishDisabled ||
                                  courseList.length ===
                                    values.elgibilty.qualification.length
                                }
                                style={{ color: '#4D566E' }}
                              />
                              <InformationIcon />
                              <Text
                                style={{ color: '#3249D7', fontWeight: 700 }}
                                strong
                              >
                                Note: Use the "And" option to add a combination.
                              </Text>
                            </Space>
                          )}
                        </>
                      )}
                  </div>
                ))}
              </>
            )}
          </FieldArray>
          <Skills
            skillList={listOfSkills}
            handleSearch={handleSearch}
            skillLoading={skillLoading}
            getListOfSkills={getListOfSkills}
            disabled={rePublishedPublishDisabled}
            skillRefetch={skillRefetch}
            roleId={roleData?.id}
            roleData={roleData}
          />
          <DropDown
            options={yearOptions}
            placeholder="Select Year"
            value={values.elgibilty.yearOfPassing || []}
            mode="multiple"
            name="elgibilty.yearOfPassing"
            onChange={selectedValues => {
              setFieldValue('elgibilty.yearOfPassing', selectedValues)
            }}
            valueParam="value"
            nameParam="label"
            label={`Year of passing ${isOffCampus ? '' : '*'}`}
            onBlur={handleBlur}
            error={getFieldError('yearOfPassing')}
            disabled={rePublishedPublishDisabled}
            showSearch={true}
            isFilterOption={false}
            onSearch={debounce(setYearSearch, 400)}
          />
          <LabelInput>Score(Percentage)</LabelInput>
          <p>
            If any students scored below this score, they are not eligible to
            apply (only if they provide a score).
          </p>
          <RadioGroupField
            options={scores}
            border={true}
            // label="Select Period *"
            name="elgibilty.scoreCondition"
            onChange={val => {
              setFieldValue('elgibilty.scoreCondition', val)

              const resetScores = {}
              filteredEducationLevels.forEach(level => {
                resetScores[level.value] = 0
              })
              setFieldValue('elgibilty.scores', resetScores)
            }}
            value={values.elgibilty.scoreCondition}
            disabled={rePublishedPublishDisabled}
          />
          <Chart>
            <SubChart>
              {filteredEducationLevels.map(level => {
                const scoreKey = level.value
                const displayName = level.name
                return (
                  <ChartElement key={scoreKey}>
                    <Level>{displayName}</Level>-{' '}
                    <Marks>
                    <StyledInputCustom
  type="text"                // use text to block +, -, e
  inputMode="numeric"        // still shows numeric keypad
  pattern="[0-9]*"           // restricts to digits only
  width={'70px'}
  suffix={'%'}
  value={values.elgibilty.scores?.[scoreKey] ?? ''}
  onChange={e => {
    const rawValue = e.target.value;

    // Allow only digits or empty string
    if (!/^\d*$/.test(rawValue)) {
      return; // ignore invalid input
    }

    const value = rawValue === '' ? '' : Number(rawValue);

    // Prevent numbers outside 0–100
    if (value !== '' && (value < 0 || value > 100)) {
      return;
    }

    if (values.elgibilty.scoreCondition === 'AVERAGE') {
      const newScores = { ...values.elgibilty.scores };
      filteredEducationLevels.forEach(eduLevel => {
        newScores[eduLevel.value] = value;
      });
      if (scoreKey === 'UGDiplomaScore' || scoreKey === 'PGDiplomaScore') {
        newScores['UGDiplomaScore'] = value;
        newScores['PGDiplomaScore'] = value;
      }
      setFieldValue('elgibilty.scores', newScores);
    } else {
      if (scoreKey === 'UGDiplomaScore' || scoreKey === 'PGDiplomaScore') {
        setFieldValue('elgibilty.scores.UGDiplomaScore', value);
        setFieldValue('elgibilty.scores.PGDiplomaScore', value);
      }
      setFieldValue(`elgibilty.scores.${scoreKey}`, value);
    }
  }}
  placeholder="0"
  disabled={rePublishedPublishDisabled}
/>

                    </Marks>
                  </ChartElement>
                )
              })}
            </SubChart>
          </Chart>
          <LabelInput>Arrears / Backlogs *</LabelInput>
          <MarginDiv>
          {touched['elgibilty.isNoArrearsAllowed'] && errors?.elgibilty?.isNoArrearsAllowed && (
            <p style={{ color: 'red', margin: '0 0 4px 0', fontSize: '12px' }}>
              {errors.elgibilty.isNoArrearsAllowed}
            </p>
          )}
            <Checkbox
              checked={values.elgibilty.isArrearsAllowed}
              onChange={e => {
                setFieldValue('elgibilty.isArrearsAllowed', e.target.checked)
                if (e?.target?.checked) {
                  setFieldValue('elgibilty.isNoArrearsAllowed', false)
                } else {
                  setFieldValue('elgibilty.arrearCount', 0)
                }
              }}
              label={'Allow current arrears'}
              disabled={rePublishedPublishDisabled}
            />
            <ArrearSubText>Any arrears that are not cleared</ArrearSubText>
            {values.elgibilty.isArrearsAllowed && (
              <Wrapper column>
                <LabelWrapper>Enter no. of current arrears*</LabelWrapper>
                <InputText
                  min={0}
                  type="number"
                  inputMode="numeric"
                  value={values?.elgibilty?.arrearCount ?? 0}
                  onChange={e => {
                    const raw = e.target.value ?? ''
                    const digitsOnly = String(raw).replace(/\D/g, '')
                    setFieldValue('elgibilty.arrearCount', digitsOnly)
                  }}
                  onKeyDown={e => {
                    if (e.key === '.' || e.key === 'e' || e.key === '-' || e.key === '+') {
                      e.preventDefault()
                    }
                  }}
                  style={{ width: 180 }}
                  name="elgibilty.arrearCount"
                  onBlur={handleBlur}
                  error={errors?.elgibilty?.arrearCount ?? ''}
                  disabled={rePublishedPublishDisabled}
                />
              </Wrapper>
            )}
          </MarginDiv>
          <MarginDiv>
            <Checkbox
              checked={values.elgibilty.isHistoryArrears}
              onChange={e => {
                setFieldValue('elgibilty.isHistoryArrears', e.target.checked)
                if (e?.target?.checked) {
                  setFieldValue('elgibilty.isNoArrearsAllowed', false)
                } else {
                  setFieldValue('elgibilty.historyArrearCount', 0)
                }
              }}
              label={'Allow history of arrears'}
              disabled={rePublishedPublishDisabled}
            />
            <ArrearSubText>
              Any arrears of the past that are cleared
            </ArrearSubText>
            {values.elgibilty.isHistoryArrears && (
              <Wrapper column>
                <LabelWrapper>Enter no. of history of arrears*</LabelWrapper>
                <InputText
                  min={0}
                  type="number"
                  inputMode="numeric"
                  value={values?.elgibilty?.historyArrearCount ?? 0}
                  onChange={e => {
                    const raw = e.target.value ?? ''
                    const digitsOnly = String(raw).replace(/\D/g, '')
                    setFieldValue('elgibilty.historyArrearCount', digitsOnly)
                  }}
                  onKeyDown={e => {
                    if (e.key === '.' || e.key === 'e' || e.key === '-' || e.key === '+') {
                      e.preventDefault()
                    }
                  }}
                  onBlur={handleBlur}
                  error={errors?.elgibilty?.historyArrearCount ?? ''}
                  style={{ width: 180 }}
                  name="elgibilty.historyArrearCount"
                  disabled={rePublishedPublishDisabled}
                />
              </Wrapper>
            )}
          </MarginDiv>
          <MarginDiv>
            <Checkbox
              checked={!!values.elgibilty.isNoArrearsAllowed}
              onChange={() => {
                const next = !values.elgibilty.isNoArrearsAllowed
                setFieldValue('elgibilty.isNoArrearsAllowed', next)
                if (next) {
                  setFieldValue('elgibilty.isArrearsAllowed', false)
                  setFieldValue('elgibilty.isHistoryArrears', false)
                  setFieldValue('elgibilty.historyArrearCount', 0)
                  setFieldValue('elgibilty.arrearCount', 0)
                }
              }}
              label={'No arrears allowed'}
              disabled={rePublishedPublishDisabled}
            />
            <ArrearSubText>
              No current or history of arrears allowed
            </ArrearSubText>
          </MarginDiv>
        </div>
      )}
    </>
  )
}

export default EligibilityCriteria
